export const notFoundImage =
  'https://cdn.hackforplay.xyz/ogp-image/not-found-bomy.png';

export const skinIcons = 'https://skins.hackforplay.xyz/_icons';

export const skinNames = 'https://skins.hackforplay.xyz/_names.json';

export const commonFromCdn = 'https://cdn.hackforplay.xyz/common';
